import { MUTATION_GROUP } from './constants';
import type { JiraSingleLineTextFieldInput } from './types';

export const mutateTextField = (value: string, fieldId: string): JiraSingleLineTextFieldInput => ({
	fieldId,
	text: value,
	mutationGroup: MUTATION_GROUP,
});
